import {schema} from 'modules/common/components/Form'

export default schema.object({
  message: schema
    .string()
    .trim()
    .required(),
})
